import {warnAndRedirectAfterInaccessiblePageOpen} from 'auth/capabilities/InaccessibleFeaturesActions';
import BenchlingConfig from 'BenchlingConfig';
import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const ChemistryRoutes: RouteBundle = {
  domain: 'chemistry',
  routes: [
    {
      urlPattern: 'salts/listing',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        EditorRoutes.saltLibrary();
      },
    },
    {
      urlPattern: 'solvents/listing',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        EditorRoutes.solventLibrary();
      },
    },
  ],
};
